export default {"src":"/_next/static/media/manawu.cfef875a.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};